import "./styles.scss";

export const Spinner = () => {
  return <div className="spinner"></div>;
};
